module.exports = __webpack_public_path__ + "assets/img/ic-N-bling.b9dd3725.png";